import { fromJS } from 'immutable'
import {
  ACCOUNTING_PAYING_LIST_REQUEST,
  ACCOUNTING_PAYING_LIST_SUCCESS,
  ACCOUNTING_PAYING_LIST_FAILURE,
} from '../../actions/accounting-dashboard/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case ACCOUNTING_PAYING_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case ACCOUNTING_PAYING_LIST_SUCCESS:
      return state
        .set('accountantPayings', fromJS(action.payload.accountantPayings))
        .set('isFetching', false)
    case ACCOUNTING_PAYING_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/paying-list-reducer.js